// import qs from "qs";
import { addError } from './error';
import api from '../../helpers/ApiClient';

export const REQUEST_AUTOCOMPLETE = 'REQUEST_AUTOCOMPLETE';
export const RECEIVE_AUTOCOMPLETE = 'RECEIVE_AUTOCOMPLETE';
export const FAIL_AUTOCOMPLETE = 'FAIL_AUTOCOMPLETE';
export const CLEAR_AUTOCOMPLETE = 'CLEAR_AUTOCOMPLETE';

function receiveAutoComplete(json, word) { 
  return {
    type: RECEIVE_AUTOCOMPLETE,
    payload: {
      items: json,
      word,
      receivedAt: Date.now(),
    }
  };
}

function requestAutoComplete(word) {
  return {
    type: REQUEST_AUTOCOMPLETE,
    payload: {
      word,
    }
  };
}

function failAutoComplete(word){
  return {
    type: FAIL_AUTOCOMPLETE,
    payload: {
      word,
    }
  };
}

function shouldFetchAutoComplete(state, word) {
  if (!word) {
    return false;
  }
  const results = state.autoComplete;
  if (results && results.loading) {
    return false;
  } else {
    return true;
  }
}

function fetchAutoCompleteFromApi(word) {
  return dispatch => {
    dispatch(requestAutoComplete(word));
    return api(`/ikea/ikea/search?query=${word}`)
      .then(json => dispatch(receiveAutoComplete(json, word)))
      .catch(err => {
        dispatch(failAutoComplete(word));
        dispatch(addError(err));
      });
  };
}

export function fetchAutoComplete(word) {
  word = word.trim();
  return (dispatch, getState) => {
    if (shouldFetchAutoComplete(getState(), word)) {
      return dispatch(fetchAutoCompleteFromApi(word));
    }
  };
}

export function clearAutoComplete(){
  return {
    type: CLEAR_AUTOCOMPLETE,
  };
}